import { container } from "tsyringe";
import { isTestMarketCountry } from "../../../utils/testMarket";
const handleLocationChangeSearchBar = ({ e, setLocations, setSelectedPickupLocation, setSelectedReturnLocation, setNoResults, checked, userCountry = "US" }) => {
    const resolveUserCountry = () => {
        var _a;
        const countryFromSession = typeof window !== "undefined" ? sessionStorage.getItem("country") : null;
        const normalized = ((_a = countryFromSession !== null && countryFromSession !== void 0 ? countryFromSession : userCountry) !== null && _a !== void 0 ? _a : "US").toString().trim().toUpperCase();
        return normalized;
    };
    const getLocationsByName = () => {
        const normalizedCountry = resolveUserCountry();
        const shouldUseGateway = isTestMarketCountry(normalizedCountry);
        return container.resolve(shouldUseGateway ? "iUseCaseGetLocationsByName" : "iUseCaseGetLocationsByNameClassic");
    };
    setLocations([]);
    if (e.target.id == "pickup_location") {
        setSelectedPickupLocation([e.target.value, "", 1]);
        if (checked == false) {
            setSelectedReturnLocation([e.target.value, "", 1]);
        }
    }
    else {
        setSelectedReturnLocation([e.target.value, "", 1]);
    }
    if (e.target.value.length > 2) {
        getLocationsByName().handle(e.target.value).then((data) => {
            if (data != undefined && data.length > 0) {
                setLocations(data);
                setNoResults(false);
            }
            else {
                setNoResults(true);
                setLocations([]);
            }
        });
    }
    else {
        setNoResults(false);
    }
};
export default handleLocationChangeSearchBar;
